import { MenuButton } from '@headlessui/react';
import { Body3, Caption2 } from 'components/Common';
import styled from 'styled-components';

/* 패딩은 뷰포트가 아니라 렌더 변형($mobile)을 따른다 — 관리자 계정은 900px 미만에서
   모바일 헤더를 쓰므로(GNB 미수용) 뷰포트 미디어만으로는 패딩·높이(Spacing 74/99)가 어긋난다.
   데스크톱 GNB 변형의 좌우 여백만 태블릿(<1280px)에서 축소한다(메뉴 간격 50px는 동일). */
export const Header = styled.div<{
  color?: string;
  $mobile?: boolean;
}>`
  position: fixed;
  background-color: ${({ theme, color }) => (color ? theme.color[color] : theme.color.White)};
  z-index: 10;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  padding: ${({ $mobile }) => ($mobile ? '20px 24px' : '31px 114px')};
  box-sizing: border-box;

  @media (max-width: 1279px) {
    padding: ${({ $mobile }) => ($mobile ? '20px 24px' : '31px 24px')};
  }
`;

/* 데스크톱 GNB 행 — 간격은 전 구간 데스크톱과 동일(50px) */
export const LogoNavRow = styled.div`
  display: flex;
  gap: 50px;
`;

export const NavRow = styled.div`
  display: flex;
  gap: 50px;
`;

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  background-color: green;
  margin-left: 5rem;
  margin-right: 5rem;
`;

export const HeaderText = styled.p`
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  font-family: 'Apple SD Gothic Neo', 'Noto Sans KR', sans-serif;
`;

export const Button = styled.div`
  padding: 8px 15px;
  border-radius: 36px;
  border: 1.5px solid ${({ theme }) => theme.color.Red};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const UserMenuButton = styled(MenuButton)`
  padding: 8px 15px;
  border-radius: 36px;
  background-color: ${({ theme }) => theme.color.Red};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  ::after {
    content: url('/Arrow_Down.svg');
  }
`;

export const LogOutCaption = styled(Caption2)`
  z-index: 11;
`;

export const UserMenuItemButton = styled.button`
  margin-top: 8px;
  box-sizing: border-box;
  padding: 10px 20px;
  border-radius: 36px;
  background-color: ${({ theme }) => theme.color.White};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
`;

export const LinkButton = styled(Body3)`
  cursor: pointer;
  :hover {
    color: ${({ theme }) => theme.color.Red};
  }
`;

export const SubLinkButton = styled(Caption2)`
  cursor: pointer;
  padding: 16px 24px;
  width: 100%;
  box-sizing: border-box;
  text-align: start;
  color: rgba(107, 107, 107, 1);
  white-space: nowrap;
  :hover {
    color: ${({ theme }) => theme.color.Red};
  }
`;

export const DropdownBlock = styled(Wrap)`
  margin: 0px;
  z-index: 100;
  flex-direction: column;
  display: none;
  left: 0px;
  top: 24px;
  position: absolute;
  width: 180px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: ${({ theme }) => theme.color.White};
`;

export const DropdownContainer = styled.div`
  position: relative;
  :hover {
    color: ${({ theme }) => theme.color.Red};
    ${LinkButton} {
      color: ${({ theme }) => theme.color.Red};
    }
    ${DropdownBlock} {
      display: flex;
    }
  }
`;
